export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '점검대상'}, {name: '점검장소'}, {name: '재해형태'}, {name: '점검일'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).inspectionTitle // 점검대상
      case 2: return func.getContent(value).stdInfo.점검장소 // 점검장소
      case 3: return func.getContent(value).stdInfo.재해형태 // 재해형태
      case 4: return func.getContent(value).stdInfo.점검일 // 점검일
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]')

    switch (nav.value.searchType) {
    case '회사명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '점검대상': returnData.push('content$body.inspectionTitle*%[:default_skw]%'); break
    case '점검장소': returnData.push('content$body.stdInfo."점검장소"*%[:default_skw]%'); break
    case '점검일': returnData.push('content$body.stdInfo."점검일"*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
